import { Grid } from '@mui/material';
import React from 'react';
import * as css from './activity.psa.module.scss';
import translations from './activity.psa.i18n';
import { useActivityContextPSA } from './activitycontexts';
import { FakeLockedInput } from '../components/input';
import FritekstSectionReadOnly from './common/fritekstsectionreadonly';
import { useFormatMessageFor } from '../i18n/translation';

const Detaljer = () => {
  const { praksisaktivitet } = useActivityContextPSA();
  const { sted, praksis, klasse, krav, fritekst } = praksisaktivitet;
  const { emne, presentertNavn, bokstav } = klasse;
  const labels = useFormatMessageFor(translations);

  return (
    <>
      <div className={css.verticalMargin}>
        <Grid container spacing={3}>
          <Grid item xs={9}>
            <FakeLockedInput
              label={labels.activitybestiller}
              value={sted.navn[0]}
            />
          </Grid>
          <Grid item xs={3}>
            <FakeLockedInput label={labels.activitystatus} value={''} />
          </Grid>
          <Grid item xs={4}>
            <FakeLockedInput
              label={labels.activitypraksistype}
              value={praksis.navn}
            />
          </Grid>
          <Grid item xs={4}>
            <FakeLockedInput
              label={labels.activityemnenavn}
              value={emne.navn}
            />
          </Grid>
          <Grid item xs={2}>
            <FakeLockedInput
              label={labels.activityklasse}
              value={presentertNavn || bokstav}
            />
          </Grid>
          <Grid item xs={2}>
            <FakeLockedInput
              label={labels.activityemnebeskrivelse}
              value={emne.kode}
            />
          </Grid>
          <Grid item xs={4}>
            <FakeLockedInput
              label={labels.activitykrav}
              value={krav ? krav : labels.activityingenkrav}
            />
          </Grid>
          {fritekst && (
            <FritekstSectionReadOnly
              fritekst={fritekst}
              title={labels.fritekstTitle}
              subtitle={labels.fritekstSubtitle}
            />
          )}
        </Grid>
      </div>
    </>
  );
};

export default Detaljer;
